(ns practitest.frontend.users-view.subs
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub ::state (fn [db _] (:users-view db)))
(re-frame/reg-sub ::loading? :<- [::state] (fn [s _] (boolean (:loading? s))))
(re-frame/reg-sub ::users :<- [::state] (fn [s _] (:users s)))
(re-frame/reg-sub ::seat-type-options :<- [::state] (fn [s _] (:seat-type-options s)))
(re-frame/reg-sub ::all-groups :<- [::state] (fn [s _] (:all-groups s)))
(re-frame/reg-sub ::active-modal :<- [::state] (fn [s _] (:active-modal s)))
(re-frame/reg-sub ::modal-row :<- [::state] (fn [s _] (:modal-row s)))
(re-frame/reg-sub ::rename-value :<- [::state] (fn [s _] (:rename-value s)))
(re-frame/reg-sub ::pat-value :<- [::state] (fn [s _] (:pat-value s)))
(re-frame/reg-sub ::current-user-id :<- [::state] (fn [s _] (:current-user-id s)))
(re-frame/reg-sub ::full-data? :<- [::state] (fn [s _] (boolean (:full-data? s))))
(re-frame/reg-sub ::seats-usage :<- [::state] (fn [s _] (get s :seats-usage [])))
(re-frame/reg-sub ::pat-for-new-users-supported? :<- [::state] (fn [s _] (boolean (:pat-for-new-users-supported? s))))
(re-frame/reg-sub ::pat-for-new-users? :<- [::state] (fn [s _] (boolean (:pat-for-new-users? s))))
(re-frame/reg-sub ::notify-license-change-supported? :<- [::state] (fn [s _] (boolean (:notify-license-change-supported? s))))
(re-frame/reg-sub ::notify-license-change? :<- [::state] (fn [s _] (boolean (:notify-license-change? s))))
(re-frame/reg-sub ::current-page :<- [::state] (fn [s _] (get s :current-page 1)))
(re-frame/reg-sub ::total-count :<- [::state] (fn [s _] (get s :total-count 0)))
